import { SearchService } from '@weave/schema-gen-ts/dist/schemas/search/v1/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSearch = bindHTTP(SearchService);
